import React from "react";
import "./timeslot-styles.scss";
import Select from "react-select";

const TimeslotDropdown = ({ value, onChange, timeslots }) => {
  const timeslotOptions = timeslots.map(timeslot => ({
    value: timeslot.timeslot,
    label: timeslot.timeslot
  }))

  return (
    <Select
      className="custom-select"
      classNamePrefix="custom-select"
      value={{value, label: value}}
      onChange={(selectedOption) => {
        onChange(selectedOption.label);
      }}
      options={timeslotOptions}
    />
  );
};

export default TimeslotDropdown;
